// Detecta que hay una versión nueva de la app publicada (build distinto) y avisa para actualizar.
// Evita que las PWA instaladas de los técnicos sigan con código viejo durante días.
import { toast } from 'sonner';

let avisado = false;
let mainActual = null;

const scriptPrincipalCargado = () =>
  Array.from(document.scripts).map((s) => s.src).find((src) => /\/static\/js\/main\.[^/]+\.js$/.test(src)) || null;

const ofrecerActualizar = () => {
  if (avisado) return;
  avisado = true;
  toast.info('Hay una versión nueva de FRESHEN-EM disponible', {
    duration: Infinity,
    description: 'Tu avance de planilla queda guardado en el dispositivo.',
    action: { label: 'Actualizar ahora', onClick: () => window.location.reload() },
  });
};

export const verificarActualizacion = async () => {
  if (!navigator.onLine) return;
  try {
    const r = await fetch(`/asset-manifest.json?ts=${Date.now()}`, { cache: 'no-store' });
    if (!r.ok) return;
    const man = await r.json();
    const mainPublicado = man?.files?.['main.js'];
    if (!mainPublicado) return; // build de desarrollo: sin hash
    if (!mainActual) mainActual = scriptPrincipalCargado();
    if (!mainActual) return;
    const publicado = new URL(mainPublicado, window.location.origin).pathname;
    const actual = new URL(mainActual, window.location.origin).pathname;
    if (publicado !== actual) ofrecerActualizar();
  } catch { /* noop */ }
};

export const iniciarChequeoActualizaciones = (registration) => {
  // 1) El navegador instaló un service worker nuevo → recargar para tomar el código nuevo
  if (registration) {
    registration.addEventListener('updatefound', () => {
      if (!navigator.serviceWorker?.controller) return; // primera instalación: no es una versión nueva
      const nuevo = registration.installing;
      nuevo?.addEventListener('statechange', () => { if (nuevo.state === 'activated') ofrecerActualizar(); });
    });
  }
  // 2) Al volver a la app (visible) o al recuperar red, comparar el build publicado con el cargado
  document.addEventListener('visibilitychange', () => {
    if (document.visibilityState === 'visible') { verificarActualizacion(); registration?.update?.().catch(() => {}); }
  });
  window.addEventListener('online', verificarActualizacion);
  setInterval(verificarActualizacion, 30 * 60 * 1000);
  setTimeout(verificarActualizacion, 15000);
};
